
import { Component, Mixins } from "vue-property-decorator";
import { Color, TextStyle } from "../../../../../../../base/domain/drawing";
import { default as RectangleCoordinatableObjectDrawerBase } from "./RectangleCoordinatableObjectDrawerBase.vue";

@Component
export default class DateTextDrawableObjectDrawerBase extends Mixins(RectangleCoordinatableObjectDrawerBase) {
  get textStyle(): TextStyle {
    const textStyle = this.readPropertyOrDefault(s => s.textStyle().getValue(), null);
    return textStyle
      ? new TextStyle(
        new Color(textStyle.fontStyle.color.value),
        textStyle.alignment,
        textStyle.fontStyle.font.size,
        null,
        textStyle.fontStyle.font.family,
      )
      : null;
  }
}
